import { useGetOrgList } from "@src/api/organizations-list/get-organization-list";

import { useGetOrg } from "../organizations/get-organization";

export const useIsIntelligems = () => {
  const org = useGetOrg();
  const orgList = useGetOrgList();

  if (org.isError) {
    return false;
  }

  if (!orgList.isSuccess) {
    return undefined;
  }

  const foundOrg = orgList.data.orgs.find((o) => o.id === org.data.org.id);
  const userRoles = foundOrg ? foundOrg.roles : ["member"];

  return userRoles.some((role) => role === "intelligems");
};
